import { DevicePenIcon } from "@jti/brand-icons/device-pen";
import { DeviceTimeIcon } from "@jti/brand-icons/device-time";
import { HandChooseIcon } from "@jti/brand-icons/hand-choose";
import { HandCoinsIcon } from "@jti/brand-icons/hand-coins";
import { HandDobbleIcon } from "@jti/brand-icons/hand-dobble";

import { createDisplayResolver } from "./createDisplayResolver";

export const SERVICE_CONFIG = {
  TRY_A_DEVICE: {
    icon: <HandChooseIcon />,
    i18nKey: "store_locator.services.try_a_device",
  },
  BORROW_A_DEVICE: {
    icon: <DeviceTimeIcon />,
    i18nKey: "store_locator.services.borrow_a_device",
  },
  TRADE_YOUR_DEVICE: {
    icon: <HandDobbleIcon />,
    i18nKey: "store_locator.services.trade_your_device",
  },
  MEMBER_GET_MEMBER: {
    icon: <HandCoinsIcon />,
    i18nKey: "store_locator.services.member_get_member",
  },
  CUSTOMIZE_YOUR_DEVICE: {
    icon: <DevicePenIcon />,
    i18nKey: "store_locator.services.customize_your_device",
  },
} as const;

const LEGACY_SERVICE_MAP = {
  tryadevice: "TRY_A_DEVICE",
  borrowadevice: "BORROW_A_DEVICE",
  tradeyourdevice: "TRADE_YOUR_DEVICE",
  membergetmember: "MEMBER_GET_MEMBER",
  customizeyourdevice: "CUSTOMIZE_YOUR_DEVICE",
} as const;

const serviceResolver = createDisplayResolver(SERVICE_CONFIG, LEGACY_SERVICE_MAP);

export type ServiceId = keyof typeof SERVICE_CONFIG;
export const normalizeServiceKey = serviceResolver.normalizeKey;
export const resolveServiceId = serviceResolver.resolveId;
export const getServiceDisplay = serviceResolver.getDisplay;
